//@ts-nocheck

import styled, { css } from 'styled-components';
import palette from '../../../theme/palette';
import { Heading, Paragraph } from '../../atoms/Typography/Typography.styles';

export const CalendarContainer = styled.div`
  display: flex;
  flex-direction: row;
  overflow: hidden;
  position: relative;

  ${({ theme }) => theme.mediaQuery.xl(`
    width: 100%;
    justify-content: space-between;
  `)};
`;

export const CalendarGrid = styled.div`
  width: 100%;
  border-radius: ${({ theme }) => theme.rem(24)};
  background-color: #fff;

  ${({ theme }) => theme.mediaQuery.xl(`
    width: 54%;
  `)};
`;

export const EventSidebar = styled.div`
  width: 100%;
  height: 100%;
  background-color: #f5f5f5;
  padding: 0;
  position: absolute;
  left: 0;
  bottom: 0;
  transform: translateY(100%);
  transition: transform 0.2s ease-out;

  ${({ isMobile, show }) => isMobile && show && css`
    transform: translateY(0);
  `}

  ${({ theme }) => theme.mediaQuery.xl(`
    width: 44%;
    max-height: ${theme.rem(640)};
    height: auto;
    left: auto;
    bottom: auto;
    transform: none;
    position: relative;
    border-radius: ${theme.rem(24)};
  `)}
`;

export const MonthNavigation = styled.div`
  height: ${({ theme }) => theme.rem(60)};
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${palette.green[300]};
  color: white;
  padding: ${({ theme }) => theme.rem(16)};
  border-radius: ${({ theme }) => theme.rem(24, 24, 0, 0)};

  ${({ theme }) => theme.mediaQuery.xl(`
    height: ${theme.rem(88)};
  `)}
`;

export const MonthTitle = styled.div`
  text-transform: capitalize;
  flex-grow: 1;
  text-align: center;

  > ${Heading} {
    color: #FFF;
  }
`;

export const NavButton = styled.button`
  width: ${({ theme }) => theme.rem(24)};
  height: ${({ theme }) => theme.rem(24)};
  background: #fff;
  cursor: pointer;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #fff;
  color: ${palette.green[300]};

  ${({ theme }) => theme.mediaQuery.xl(`
    width: ${theme.rem(36)};
    height: ${theme.rem(36)};
  `)}
`;

export const WeekdaysRow = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  text-align: center;
  font-weight: 500;
  border-right: 1px solid #e6e6e6;
  border-left: 1px solid #e6e6e6;
  padding: ${({ theme }) => theme.rem(8, 0)};

  > ${Heading} {
    color: #080808!important;
  }

  ${({ theme }) => theme.mediaQuery.xl(`
    padding: ${theme.rem(16, 32)};
  `)}
`;

export const DaysGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  grid-gap: 0;
  border-bottom-left-radius: ${({ theme }) => theme.rem(24)};
  border-bottom-right-radius: ${({ theme }) => theme.rem(24)};
  border-right: 1px solid #e6e6e6;
  border-left: 1px solid #e6e6e6;
  border-bottom: 1px solid #e6e6e6;
  overflow: hidden;

  ${({ theme }) => theme.mediaQuery.xl(`
    padding: ${theme.rem(0, 32, 32, 32)};
  `)};
`;

export const DayCell = styled.div<{ isCurrentMonth?: boolean; isSelected?: boolean; hasEvent?: boolean; empty?: boolean }>`
  width: 100%;
  height: ${({ theme }) => theme.rem(68)};
  padding: ${({ theme }) => theme.rem(10, 0)};
  cursor: ${({ empty }) => empty ? 'default' : 'pointer'};
  position: relative;
  display: flex;
  justify-content: center;  
  background-color: ${({ empty }) => empty ? '#fff' : '#fafafa'};
  transition: background-color 0.2s ease-out;
  
  &:hover {
    background-color: ${({ empty }) => empty ? '#fff' : palette.green[50]};
  }

  ${({ theme }) => theme.mediaQuery.md(`
    aspect-ratio: 1 / 1;
    height: auto;
  `)};

  ${({ theme, empty }) => theme.mediaQuery.xl(`
    padding: ${theme.rem(6, 10)};
    justify-content: flex-start;
    border: 1px solid ${empty ? '#fff' : '#e6e6e6'};
  `)};

  ${({ isSelected }) => isSelected && css`
    background-color: ${palette.green[50]};
  `}
`;

export const DayNumber = styled.div<{ isToday?: boolean, isMobile?: boolean }>`
  > ${Paragraph} {
    color: #080808!important;
  }

  ${({ isToday, theme, isMobile }) => isToday && isMobile && css`
    > ${Paragraph} {
      color: white!important;
    }
    position: relative;
    width: ${theme.rem(36)};
    height: ${theme.rem(36)};
    background-color: ${palette.green[200]};
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    top: ${theme.rem(-5)};
  `};
`;

export const EventIndicatorWrapper = styled.div`
  position: absolute;
  left: 50%;
  bottom: ${({ theme }) => theme.rem(8)};
  transform: translateX(-50%);
  display: flex;
  gap: ${({ theme }) => theme.rem(4)};
  flex-wrap: wrap;
  justify-content: center;
  max-width: 90%;

  ${({ theme }) => theme.mediaQuery.xl(`
    max-width: none;
    bottom: ${theme.rem(12)};
    padding: ${theme.rem(0, 16)};
    left: 0;
    width: 100%;
    transform: none;
    justify-content: flex-start;
  `)}
`

export const EventIndicator = styled.div<{ eventType?: string }>`
  width: ${({ theme }) => theme.rem(8)};
  height: ${({ theme }) => theme.rem(8)};
  border-radius: 50%;
  display: none;

  &:first-child {
    display: block;
  }

  ${({ eventType }) => eventType === 'event' && css`
    background-color: ${palette.green[200]};
  `}

  ${({ theme }) => theme.mediaQuery.xl(`
    display: block;
    width: 18%;
    height: auto;
    aspect-ratio: 1 / 1;
  `)}
`;

export const EventHeader = styled.div`
  height: ${({ theme }) => theme.rem(60)};
  background-color: ${palette.green[300]};
  border-radius: ${({ theme }) => theme.rem(24, 24, 0, 0)};
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  text-transform: capitalize;

  ${({ theme }) => theme.mediaQuery.xl(`
    height: ${theme.rem(88)};
  `)}
`;

export const EventDate = styled.div`
  > ${Heading} {
    color: #FFF;
  }
`;

export const EventList = styled.div`
  padding: ${({ theme }) => theme.rem(32)};
  height: calc(100% - ${({ theme }) => theme.rem(60)});

  ${({ theme }) => theme.mediaQuery.xl(`
    height: calc(100% - ${theme.rem(88)});
  `)}
`;

export const EventListInner = styled.div`
  height: calc(100% - ${({ theme }) => theme.rem(12)});
  padding-bottom: ${({ theme }) => theme.rem(32)};
  flex-grow: 1;

  ${({ theme }) => theme.mediaQuery.xl(`
    height: 100%;
  `)}
`;

export const EventListScrollBar = styled.div`
  overflow-y: auto;
  height: 100%;
  
  ${({ theme }) => theme.mediaQuery.xl(`
    padding-right: ${theme.rem(32)};
  `)};

  // &::-webkit-scrollbar {
  //   width: ${({ theme }) => theme.rem(4)};
  // }

  // &::-webkit-scrollbar-track {
  //   background-color: ${palette.grayscale[100]};
  //   -webkit-box-shadow: inset 0 0 10px ${palette.grayscale[200]};
  //   border-radius: ${({ theme }) => theme.rem(4)};
  // }

  // &::-webkit-scrollbar-thumb {
  //   background-color: ${palette.green[900]};
  // }

  // &::-webkit-scrollbar-thumb:hover {
  //   background-color: ${palette.grayscale[400]};
  // }
`

export const EventItem = styled.div`
  margin-bottom: 24px;
  padding: 16px;
  background-color: #f9f9f9;
  border-radius: 8px;
`;

export const EventTag = styled.div`
  display: inline-block;
  background-color: #27AE60;
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 0.8rem;
  margin-bottom: 8px;
`;

export const EventTitle = styled.h4`
  
`;

export const EventDescription = styled.p`
  color: #666;
  margin-bottom: 16px;
`;

export const EventLink = styled.a`
  display: inline-block;
  background-color: #27AE60;
  color: white;
  text-decoration: none;
  padding: 8px 16px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  width: fit-content;
  
  span {
    margin-left: 8px;
  }
  
  &:hover {
    background-color: #219653;
  }
`;

export const EventDuration = styled.div`
  color: #666;
  margin-bottom: 16px;
`;

export const CollapseButton = styled.div`
  background: none;
  border: none;
  color: white;
  cursor: pointer;
  padding: 0;

  button {
    background: transparent;
    
    &:hover {
      background: transparent!important;
    }
  }

  i {
    padding: 0!important;
    font-size: ${({ theme }) => theme.rem(10)};
    color: white!important;
    width: ${({ theme }) => theme.rem(18)};
    height: ${({ theme }) => theme.rem(18)};
    background-color: ${palette.green[300]};
    border-radius: 50%;
  }

  ${({ theme }) => theme.mediaQuery.xl(`
    display: none;
  `)}
`;